import React, { useState } from 'react';

import { Point } from './types';

export type ReturnType = [
  setCapturedCoordinates: (
    event: React.PointerEvent,
    centerPoint: Point,
    transform: (x: Point) => Point
  ) => void,
  withCapturedCoordinates: (
    event: React.PointerEvent,
    transform: (x: Point) => Point
  ) => Point | null,
  releaseCapturedCoordinates: () => void,
];

// We use this to track the point where we clicked inside the control
// and adjust the event point to the center of control.
export const useCapturedCoordinates = (
  getAreaStartPoint: () => Point
): ReturnType => {
  const [captured, setCaptured] = useState<Point | null>(null);

  const setCapturedCoordinates = (
    event: React.PointerEvent,
    centerPoint: Point,
    transform: (x: Point) => Point
  ): void => {
    const areaStartPoint = getAreaStartPoint();
    const transformed = transform({
      x: event.clientX - areaStartPoint.x,
      y: event.clientY - areaStartPoint.y,
    });
    setCaptured({
      x: transformed.x - centerPoint.x,
      y: transformed.y - centerPoint.y,
    });
  };

  const withCapturedCoordinates = (
    event: React.PointerEvent,
    transform: (x: Point) => Point
  ): Point | null => {
    if (!captured) {
      return null;
    }

    const areaStartPoint = getAreaStartPoint();
    const transformed = transform({
      x: event.clientX - areaStartPoint.x,
      y: event.clientY - areaStartPoint.y,
    });
    return { x: transformed.x - captured.x, y: transformed.y - captured.y };
  };

  const releaseCapturedCoordinates = (): void => {
    setCaptured(null);
  };

  return [
    setCapturedCoordinates,
    withCapturedCoordinates,
    releaseCapturedCoordinates,
  ];
};
